@layer ui-kit;
@layer ui-kit {
  .jnmezs0 {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    min-height: 42px;
    padding: 8px 16px;
    border-radius: 8px;
    background-color: #16171a;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.1);
    color: var(--_1iamlv4d);
    font-family: DM Sans, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }
  .jnmezs0:focus-within, .jnmezs0:active:not([data-disabled]) {
    box-shadow: inset 0 0 0 1px #FFF;
  }
  .jnmezs0[data-disabled] {
    pointer-events: none;
    color: var(--_1iamlv4e);
  }
  .jnmezs2 {
    min-height: 36px;
  }
  .jnmezs0 :where(svg) {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }
  .jnmezs3 {
    position: relative;
    display: block;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
  }
  .jnmezs4 {
    visibility: hidden;
  }
  .jnmezs3 > ._1a6kwyz1 {
    position: absolute;
    inset: 0;
    margin: 0;
    box-sizing: border-box;
  }
  .jnmezs5 {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.3;
    letter-spacing: -0.01em;
    appearance: none;
    flex: 1;
    min-width: 0;
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    color: var(--_1iamlv4a);
    font-family: DM Sans, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    outline: none;
  }
  .jnmezs5::placeholder {
    color: var(--_1iamlv4d);
  }
  .jnmezs5:focus {
    outline: none;
  }
  .jnmezs5:focus-visible {
    outline: none;
  }
  .jnmezs5:disabled::placeholder {
    color: var(--_1iamlv4e);
  }
  .jnmezs6 {
    appearance: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    cursor: pointer;
  }
  .jnmezs6:focus {
    outline: none;
  }
  .jnmezs6:focus-visible {
    outline: 2px solid var(--_1iamlv4l);
    outline-offset: 2px;
  }
  @media (hover: hover) and (pointer: fine) {
    .jnmezs0:hover:not([data-disabled]):not(:focus-within) {
      box-shadow: inset 0 0 0 1px var(--_1iamlv4i);
    }
    .jnmezs6:hover:not(:disabled) {
      color: var(--_1iamlv4a);
    }
  }
}